<template>
  <div class="app-container">
    <!--  :before-save="onBeforeSave" -->
    <common-dialog ref="dialog" width="700px" show-save-button title="考勤事件设备设置" id-key="SectionId"
      :data="data" form-label-width="100px" :form-rules="rules" :save-func="api.save" :get-data-func="api.info"
      @edit-opened="onEditOpened" @create-opened="onCreateOpened" @closed="reset" @close-saved="$emit('close-saved')">
      <template slot="form">
        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="事件名称" prop="TermId">
              <el-select v-model="name">
                <el-option :value="0" label="学生晚休考勤"></el-option>
                <el-option :value="1" label="学生留宿自习考勤"></el-option>
                <el-option :value="2" label="教职工大会"></el-option>
                <el-option :value="3" label="教师下班辅导"></el-option>
                <el-option :value="4" label="行政上下班"></el-option>
                <el-option :value="5" label="教辅上下班"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="考勤对象人群" prop="GradeId">
              <el-input type="text" placeholder="请选择考勤对象人群" @click.native="selectCrowd" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="考勤设备" prop="RollCallStartTime">
              <el-input type="text"  placeholder="请选择考勤对象人群" @click.native="selectFac" />
            </el-form-item>
          </el-col>
        </el-row>
      </template>
    </common-dialog>
    <facility-dialog ref="facilityDialog"  in-dialog selectable @select="setFace" ></facility-dialog>
    <crowd-dialog ref="crowdDialog"  in-dialog selectable @select="settCrowd" ></crowd-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import facilityDialog from '@/components/attendance/eventsetting/facility/listDialog.vue'
import crowdDialog from '@/components/attendance/eventsetting/crowd/listDialog.vue'

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    facilityDialog,
    crowdDialog
  },
  data() {

    return {
       api: require("@/api/ed/section").default,
      data: {
      },
      name:'',
      checking:"",
      isMB: this.$store.state.isMB,
      rules: {},
    };
  },
  methods: {
    onCreateOpened(data) {
    },
    onEditOpened(row) {
    },
    selectCrowd(){
        console.log('执行');
      this.$refs.crowdDialog.open().then((that) => {
        that.getData();
      });
    },
    selectFac(){
      console.log('执行');
      this.$refs.facilityDialog.open().then((that) => {
        that.getData();
      });
    },
    settCrowd(data){},
    setFace(data){},
    reset() {
      this.termList = [];
      this.gradeList = [];
    },


  },
};
</script>
<style lang="scss" scoped>

</style>